import React from 'react';
import { CardDeck } from 'reactstrap';

import PlacementCount from '~/components/Patient/Identity/PlacementCount';
import Pcp from '~/components/Patient/Identity/Pcp';
import UpcomingAppts from '~/components/Patient/Identity/UpcomingAppts';
import CurrentMeds from '~/components/Patient/Identity/CurrentMeds';

const PatientFaceSheetIdentity = () => {
  return (
    <>
      <CardDeck className="mt-3">
        <PlacementCount />
        <Pcp />
      </CardDeck>

      <CardDeck className="mt-3">
        <UpcomingAppts />
        <CurrentMeds />
      </CardDeck>
    </>
  );
};

export default PatientFaceSheetIdentity;

